var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00065 0.666748C6.36884 0.666748 6.66731 0.965225 6.66731 1.33341V9.05727L10.1959 5.52868C10.4563 5.26833 10.8784 5.26833 11.1387 5.52868C11.3991 5.78903 11.3991 6.21114 11.1387 6.47149L6.47205 11.1382C6.2117 11.3985 5.78959 11.3985 5.52924 11.1382L0.862575 6.47149C0.602225 6.21114 0.602225 5.78903 0.862575 5.52868C1.12292 5.26833 1.54503 5.26833 1.80538 5.52868L5.33398 9.05727V1.33341C5.33398 0.965225 5.63246 0.666748 6.00065 0.666748Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowDown);
export default __webpack_public_path__ + "static/media/icn-arrow-down.cda1c47100772596b4e0e7be59ff3ec0.svg";
export { ForwardRef as ReactComponent };